import React, { useState } from 'react';
import styles from './feedback.module.scss';
import Text from '../../components/Text/Text';
import FeedbackModal from './components/FeedbackModal';
import useExternalApiService from 'helpers/ExternalApiService';

interface FeedbackProps {
  callback: (rating: string, feedback: string, index: number) => void;
  onClose: () => void;
  index: number;
}

const feedbackOptions = [
  "Answered a different question",
  "Wrong people", 
  "Wrong products",
  "Wrong numbers",
  "Unclear",
  "Missing Info",
  "Irrelevant/Off-Topic",
  "Other"
] as const;

const Feedback: React.FC<FeedbackProps> = ({ index, callback, onClose }) => {
  const [showModal, setShowModal] = useState(false);
  
  
  const onSubmit = (option: string) => {
    if (option === "Other") {
      setShowModal(true);
    } else {
      callback('thumbsDown', option, index);
    }
  }

  return (
    <div className={styles.feedbackContainer}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text>Tell us why you did not like this response:</Text>
        <button 
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '1.2rem',
            padding: '4px 8px'
          }}
        >
          ✕
        </button>
      </div>
      <div className={styles.feedbackContent}>
        {feedbackOptions.map((option) => (
          <div 
            key={option}
            className={styles.feedbackCard}
            onClick={() => onSubmit(option)}
          >
            {option}
          </div>
        ))}
      </div>
      <FeedbackModal 
        callback={(opt: string) => {
          callback('thumbsDown', opt, index);
        }}
        options={feedbackOptions as unknown as string[]}
        isOpen={showModal}
        handleClose={() => {
          setShowModal(false);
        }}
      />
    </div>
  );
};

export default Feedback;
